import { useTranslation } from "react-i18next";
import { AiSuggestionsTipsList } from "../../domain/enums/AISuggestions";

const useGetDashboardTips = () => {
    const { t } = useTranslation();

    const tipsKeys = Object.values(AiSuggestionsTipsList);
    const randomKey = tipsKeys[Math.floor(Math.random() * tipsKeys.length)];

    return t(`AISuggestions.tips.${randomKey}`);
};

export default useGetDashboardTips;
